import React, { useContext } from 'react';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { AnimationsContext } from './settings/animations/animations-context';

interface Props {
	// could be disabled for any number of reasons for example a preview is playing
	isOut: boolean;
}

export default function PreviewButton(props: Props) {
	const { isOut} = props;
	const {isPreviewAnimationPlaying, handlePreviewAnimation} = useContext(AnimationsContext);
	return (
		<div
			className="preview-button"
			onClick={() => !isPreviewAnimationPlaying ? handlePreviewAnimation(isOut) : null}
			style={{
				userSelect: 'none',
				cursor: isPreviewAnimationPlaying ? 'wait' : 'pointer',
			}}
		>
			<span className="preview-button-text bl-font-l1">Preview</span>
			<Icon name={ICONS.PLAY} size={11} color={COLORS.PALE_GREEN}/>
		</div>
	);
}
